module.exports = __webpack_public_path__ + "media/images/front/confirmations_done/sections-f1cea61be01a4c195cbc9f5944d1b1e6.png";